"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6796],{

/***/ 76796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const IconMagnifyingGlass = () => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M5.13405 17.4518L2.2915 20.2943L3.7057 21.7085L6.54825 18.866L5.13405 17.4518Z", fill: "#2D2E2E" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13 3C8.59 3 5 6.59 5 11C5 14.75 7.98 19 13 19C17.41 19 21 15.41 21 11C21 6.59 17.41 3 13 3ZM13 17C9.2 17 7 13.79 7 11C7 7.69 9.69 5 13 5C16.31 5 19 7.69 19 11C19 14.31 16.31 17 13 17Z", fill: "#2D2E2E" })));
};
/* harmony default export */ __webpack_exports__["default"] = (IconMagnifyingGlass);
//# sourceMappingURL=magnifyingGlass.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)


/***/ })

}]);